import axios from "axios";
import env from "../../constants/apiConst";

export const __Trm = async (token) => {
  const options = {
    method: "GET",
    headers: {
      Authorization: token ? `Bearer ${token}` : ""
    }
  };

  const res = await axios(`${env.TRM_GET}`, options);
  return res;
};
